import styled from 'styled-components';
import Icon from '../../../_shared/components/Icon';

export const MediaContainer = styled.li`
  position: relative;
  padding: ${props => (props.isChecked ? '12px 15px' : '0')};
  background: ${({ theme }) => theme.COLORS.NEUTRAL_50};
  margin-bottom: 6px;
  display: flex;
  transition: all 0.1s ease-in-out;

  @media only screen and (max-width: ${({ theme }) =>
      theme.BP.RETAIL_CUSTOM_MOBILE_SMALL}) {
    max-width: 100%;
    max-height: 204px;
    height: min-content;
  }

  @media only screen and (min-width: ${({ theme }) =>
      theme.BP.VDP_DESKTOP_WL}) {
    max-height: 111px;
  }
`;

export const CheckboxContainer = styled.div`
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
  position: absolute;
  width: 24px;
  height: 24px;
  left: 6px;
  top: 6px;

  &[aria-checked='true'] {
    & > div {
      background: ${({ theme }) => theme.COLORS.TERTIARY};
      border: none;
    }

    path {
      fill: ${({ theme }) => theme.COLORS.BASE};
    }
  }

  svg {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    z-index: 2;
    width: 24px;
    height: 24px;
  }

  path {
    fill: ${({ theme }) => theme.COLORS.TRANSPARENT};
  }
`;

export const Checkbox = styled.div`
  position: absolute;
  width: 24px;
  height: 24px;
  border: 2px solid ${({ theme }) => theme.COLORS.BASE};
  border-radius: 50%;
  background: ${({ theme }) => theme.COLORS.TRANSPARENT};
`;

export const StyledEmptyIcon = styled(Icon).attrs({
  icon: 'TR5-No-image-camera'
})`
  width: 26px;
  height: 22px;
  margin: auto;

  path {
    fill: ${({ theme }) => theme.COLORS.NEUTRAL_30};
  }
`;

export const Image = styled.img`
  margin: auto;
  max-width: 100%;
  max-height: 100%;
  cursor: pointer;
  display: block;
`;

export const Video = styled.video`
  width: 100%;
  margin: auto;
  cursor: pointer;
`;
